import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * The Items to fix tab body (SWOOP-254 US2), rendered inside the work-order page layout at
 * `/work-orders/$workOrderId/items`. Permission / module gating is inherited from the layout route's
 * `beforeLoad`.
 */
export const Route = createFileRoute('/_authenticated/work-orders_/$workOrderId/items')({
  component: lazyRouteComponent(() => import('&/features/work-orders/pages/work-order-items-tab')),
  staticData: { titleKey: 'workOrderItems' },
});
